import { render, staticRenderFns } from "./MainTrainers.vue?vue&type=template&id=2066848f&"
import script from "./MainTrainers.vue?vue&type=script&lang=js&"
export * from "./MainTrainers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports